export function FormulaReference() {
  return (
    <div>
      <h3 className="section-title">Formula Reference</h3>
      <div style={{ display: 'grid', gap: 'var(--space-3)' }}>
        <FormulaCard
          title="CBM (Cubic Meters)"
          formula="CBM = (L × W × H × Qty) / 1,000,000"
          note="Dimensions in centimeters. For meters, divide by 1. For inches, divide by 61,023.7."
          example="100cm × 50cm × 50cm × 2 pcs = 500,000 cm³ → 0.500 CBM"
        />
        <FormulaCard
          title="Dimensional Weight (Air/Courier)"
          formula="DIM Weight = (L × W × H × Qty) / DIM Divisor"
          note="Metric: dimensions in cm, divisor typically 6000 (IATA). Imperial: dimensions in in, divisor typically 139."
          example="100cm × 50cm × 50cm × 2 / 6000 = 83.33 kg"
        />
        <FormulaCard
          title="Chargeable Weight"
          formula="Chargeable = max(Actual Weight, DIM Weight)"
          note="The higher value determines the chargeable weight for freight billing."
          example="Actual: 50 kg, DIM: 83.33 kg → Chargeable: 83.33 kg (volume-driven)"
        />
        <FormulaCard
          title="Revenue Ton (Ocean LCL)"
          formula="Revenue Ton = max(Total CBM, Gross Weight / 1000)"
          note="Ocean LCL charges by the greater of volume (CBM) or weight (revenue ton = 1000 kg)."
          example="2.5 CBM, 1500 kg → max(2.5, 1.5) = 2.5 revenue tons"
        />
        <FormulaCard
          title="Cargo Density"
          formula="Density = Gross Weight (kg) / Total CBM"
          note="Higher density = weight-driven. Lower density = volume-driven."
          example="500 kg / 2.5 CBM = 200 kg/m³"
        />
        <FormulaCard
          title="Break-Even Density"
          formula="Break-Even = 1,000,000 / DIM Divisor (kg/m³)"
          note="Above break-even = weight-driven. Below = volume-driven."
          example="Divisor 6000 → Break-even = 166.67 kg/m³"
        />
        <FormulaCard
          title="Container Count"
          formula="Containers = ceil(max(Total CBM / Container Volume, Gross Weight / Max Payload))"
          note="Takes the greater of volume-constrained or weight-constrained count."
          example="5 CBM / 33.2 CBM per 20ft = 1 container (if under weight limit)"
        />
      </div>
    </div>
  );
}

function FormulaCard({ title, formula, note, example }: { title: string; formula: string; note: string; example: string }) {
  return (
    <div
      style={{
        padding: 'var(--space-3)',
        background: 'var(--color-bg-secondary)',
        borderRadius: 'var(--radius-md)',
      }}
    >
      <div style={{ fontWeight: 'var(--font-weight-semibold)', marginBottom: 'var(--space-2)' }}>{title}</div>
      <code
        style={{
          display: 'block',
          padding: 'var(--space-2)',
          background: 'var(--color-bg-primary)',
          borderRadius: 'var(--radius-sm)',
          fontSize: 'var(--font-size-sm)',
          fontFamily: 'var(--font-family-mono)',
          marginBottom: 'var(--space-2)',
        }}
      >
        {formula}
      </code>
      <p style={{ fontSize: 'var(--font-size-xs)', color: 'var(--color-text-muted)', margin: 0 }}>{note}</p>
      <p style={{ fontSize: 'var(--font-size-sm)', color: 'var(--color-text-secondary)', margin: 'var(--space-1) 0 0' }}>
        <em>Example:</em> {example}
      </p>
    </div>
  );
}
